import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Flex } from "theme-ui";
import { useStaticQuery, graphql } from "gatsby";

interface Props {
  size?: number;
}

const MobileAppButtons = ({ size = 250 }: Props) => {
  const data = useStaticQuery(graphql`
    query {
      apple: file(
        relativePath: { eq: "download-app/download-on-the-app-store.png" }
      ) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      google: file(
        relativePath: { eq: "download-app/google-play-badge-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
    }
  `);
  return (
    <Flex
      sx={{
        gap: [2, null, null, 4],
        flexDirection: ["column", null, null, "row"],
        alignItems: ["center", null, null, "flex-start"],
        justifyContent: ["center", null, null, "flex-start"],
      }}
    >
      <a href="https://apps.apple.com/us/app/heights-finance/id1635793827">
        <GatsbyImage
          image={data.apple.childImageSharp.gatsbyImageData}
          alt="Apple store button"
          sx={{
            width: [size - 50, null, null, size - 50, size],
          }}
        />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.heightsfinance.myaccount&pcampaignid=web_share">
        <GatsbyImage
          image={data.google.childImageSharp.gatsbyImageData}
          alt="Google store button"
          sx={{
            width: [size - 50, null, null, size + 20 - 50, size + 20],
          }}
        />
      </a>
    </Flex>
  );
};

export default MobileAppButtons;
